<article
      class="group relative overflow-hidden surface-card transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 p-6 lg:p-7">
      <div
            class="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-primary-deep/5 opacity-80">
      </div>

      <div class="relative z-10 flex h-full flex-col">
            <header class="mb-5 flex items-start gap-4">
                  <div
                        class="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-primary-deep text-xl text-white shadow-md shadow-primary-glow/40 ring-1 ring-primary/30">
                        <i [class]="category.icon" aria-hidden="true"></i>
                  </div>

                  <div class="min-w-0">
                        <h3 class="text-xl font-semibold leading-tight text-text-primary">{{ category.title }}</h3>
                        <p class="mt-1 text-sm leading-6 text-text-secondary">{{ category.description }}</p>
                  </div>
            </header>

            <ul class="mb-6 space-y-2.5">
                  <li class="flex items-start gap-2.5" *ngFor="let feature of category.features">
                        <span class="mt-2 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary shadow-primary-glow shadow-sm"
                              aria-hidden="true"></span>
                        <span class="text-sm font-medium text-text-primary">{{ feature }}</span>
                  </li>
            </ul>

            <button
                  class="mt-auto inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-primary to-primary-deep px-4 py-3 text-sm font-semibold text-white shadow-md shadow-primary-glow/30 transition-all duration-300 hover:shadow-lg hover:shadow-primary-glow/50 hover:ring-1 hover:ring-primary/50"
                  type="button" (click)="navigateToPlans()">
                  <span>{{ category.buttonText }}</span>
                  <i *ngIf="category.buttonIcon" [class]="category.buttonIcon" aria-hidden="true"></i>
            </button>
      </div>
</article>